import React from 'react'

import i18n from 'i18n-literally'
import { useConnect } from 'redux-bundler-hook'

import { Box, Typography } from '@mui/material'

import ConfirmationDialog from '~/src/UI/Shared/ConfirmationDialog'

const EULA_URLS = {
  DEFAULT: 'https://aroya.io/en/company/subscription-agreement',
  GO: 'https://aroyago.io/license-agreement/',
}

const EULA_TYPE = {
  DEFAULT: i18n`Software-as-a-service Subscription Agreement`,
  GO: i18n`AROYA GO License Agreement`,
}

export const EulaDialogComponent = props => {
  const { tier, onCancel, onConfirm } = props
  const { [tier]: eulaUrl = EULA_URLS.DEFAULT } = EULA_URLS
  const { [tier]: eulaType = EULA_TYPE.DEFAULT } = EULA_TYPE

  return (
    <ConfirmationDialog
      dataTestId="aroya-eula-acceptance-dialog"
      open
      title={eulaType}
      cancelText={i18n`No`}
      confirmText={i18n`Yes`}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <Typography>
        {i18n`I have read and agree to the `}
        <Box
          color="primary.main"
          component="a"
          href={eulaUrl}
          rel="noopener"
          target="_blank"
          textDecoration="underline"
        >
          {eulaType}
        </Box>.
      </Typography>
    </ConfirmationDialog>
  )
}

const Connected = props => {
  const { currentFacility, doEulaAccept, doLogout } = useConnect('selectCurrentFacility', 'doEulaAccept', 'doLogout')

  return (
    <EulaDialogComponent
      {...props}
      tier={currentFacility.tier}
      onCancel={doLogout}
      onConfirm={doEulaAccept}
    />
  )
}

export default Connected
